import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchItems, fetchListItems } from '../../../hooks/useCrud';
import { formatDateTimeFR, truncateText } from '../../../api/callApi';
import { fileUrl } from '../../../api/config';
import DOMPurify from 'dompurify';

interface Site {
    id?: number;
    nom?: string;
    description?: string;
    email?: string;
    adresse?: string;
    tel1?: string;
    tel2?: string;
    tel3?: string;
    token?: string;
    about?: string;
    mission?: string;
    objectif?: string;
    politique?: string;
    condition?: string;
    logo?: string;
    logoFile?: File;
    facebook?: string;
    linkedin?: string;
    twitter?: string;
    youtube?: string;
    whatsapp?: string;
    createdAt?: string;
    updatedAt?: string;
}
interface UiCatBlog {
    id?: number;
    titre?: string;
    slug?: string;
    createdAt?: string;
    updatedAt?: string;
}

interface Joueur {
    id?: number;
    equipe_id: number;
    nom: string;
    prenom: string;
    date_naissance: string;
    taille?: string | number;
    poids?: string | number;
    poste?: 'Meneur' | 'Arriere' | 'Ailier' | 'Ailier_fort' | 'Pivot';
    numero_maillot?: string | number;
    photo?: string;
    logoFile?: File; // Pour le fichier image temporaire
    equipe?: any; // Inclure les détails de l'équipe

    created_at?: string;
    updated_at?: string;
    equipe_nom?: string;
}

export interface Match {
    id?: number;
    tournoi_id: number;
    equipe_domicile_id: number;
    equipe_exterieur_id: number;
    date_match: string;
    lieu?: string;
    statut: 'planifie' | 'en_cours' | 'termine';
    score_domicile?: string | number;
    score_exterieur?: string | number;
    created_at?: string;
    updated_at?: string;
    tournoi_nom?: string;
    tournoi?: any;
    equipe_domicile?: any;
    equipe_exterieur?: any;

}

interface UiService {
    id?: number;
    nom?: string;
    titre?: string;
    icone?: string;
    description?: string;
    slug?: string;

    createdAt?: string;
    updatedAt?: string;
}
export default function SideBarInfo() {
    const [sites, setSites] = useState<Site[]>([]);
    const [categories, setCategories] = useState<UiCatBlog[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [matchs, setMatchs] = useState<Match[]>([]);
    const [nextMatchs, setNextMatchs] = useState<Match[]>([]);
    const [joueurs, setJoueurs] = useState<Joueur[]>([]);
    const [uiServices, setUiServices] = useState<UiService[]>([]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<Site>('/fetch_data_site');
            setSites(res.data);

            // console.log(res);
        } finally {
            setLoading(false);
        }

    }

    const fetchListCategorie = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiCatBlog>('/fetch_category_blog_data');
            setCategories(res.data);

            // console.log(res);
        } finally {
            setLoading(false);
        }

    }

    // Chargement des matchs
    const loadMatchs = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<Match>('/fetch_one_match');
            setMatchs(res.data);

        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Chargement des matchs
    const loadNextMatchs = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<Match>('/fetch_next_match');
            setNextMatchs(res.data);
            setLoading(false);

        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Chargement des matchs
    const loadJoueurs = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<Joueur>('/fetch_popular_joueur');
            setJoueurs(res.data);
            setLoading(false);

        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Calculer l'âge à partir de la date de naissance
    const calculateAge = (dateNaissance: string): number => {
        const today = new Date();
        const birthDate = new Date(dateNaissance);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    const fetchService = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiService>('/fetch_service');
            setUiServices(res.data);

            // console.log(res);
        } finally {
            setLoading(false);
        }

    }




    useEffect(() => {
        fetchData();
        fetchListCategorie();
        loadMatchs();
        loadNextMatchs();
        loadJoueurs();
        fetchService();
    }, []);
    return (
        <div className="vstack gap-1 h-100">

            {/*Bloc Match Prochain avec Compte à Rebours */}
            <div className="panel p-4 bg-gray-25 dark:bg-gray-800 rounded-lg">
                <div className="vstack gap-3">
                    <h3 className="h5 m-0 text-primary">
                        <i className="fas fa-running"></i>
                        Match Prochain
                    </h3>

                    {/*Équipes */}
                    {
                        matchs.length === 0 ? (
                            <div>
                                <p>Aucun match trouvé</p>
                            </div>
                        ) : matchs.map((match, index) => (

                            <div className="widget widget_next_match" key={index}>



                                <div className="panel p-3 bg-white dark:bg-gray-700 rounded">

                                    <h5>{truncateText(match.tournoi.nom || '-', 25)}</h5>
                                    <span>Saison:{truncateText(match.tournoi.saison || '-', 25)}</span>


                                    <div className="hstack justify-between gap-3">
                                        <div className="vstack gap-2 text-center">
                                            <div className="w-60px h-60px bg-gray-200 dark:bg-gray-600 rounded-circle mx-auto overflow-hidden">
                                                <img src={`${fileUrl}/images/${match.equipe_domicile?.logo ?? 'logo.png'}`} alt="Lions du Kivu"
                                                    className="w-100 h-100 object-cover" />
                                            </div>
                                            <span className="fs-6 fw-bold">
                                                {match.equipe_domicile?.nom || 'Domicile'}
                                            </span>
                                        </div>

                                        <div className="vstack gap-1 text-center">
                                            <span className="fs-5 fw-bold text-primary">VS</span>
                                            <span className="fs-7 text-gray-600">{formatDateTimeFR(match.date_match)}</span>
                                            <span className="fs-7 text-gray-600">{truncateText(match.lieu || '-', 15)}</span>
                                        </div>

                                        <div className="vstack gap-2 text-center">
                                            <div className="w-60px h-60px bg-gray-200 dark:bg-gray-600 rounded-circle mx-auto overflow-hidden">
                                                <img src={`${fileUrl}/images/${match.equipe_exterieur?.logo ?? 'logo.png'}`} alt="Ouragan Butembo" className="w-100 h-100 object-cover" />
                                            </div>
                                            <span className="fs-6 fw-bold">{match.equipe_exterieur?.nom || 'Extérieur'}</span>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        ))
                    }


                </div>
            </div>

            {/*Bloc Joueurs en Vedette */}
            <div className="panel p-4 bg-gray-25 dark:bg-gray-800 rounded-lg">
                <h3 className="h5 m-0 mb-3 text-primary">
                    <i className="fas fa-star"></i>
                    Joueurs en Vedette
                </h3>
                <div className="vstack gap-2">


                    {/*Joueur 1 */}
                    {joueurs.length === 0 ? (
                        <div className='text-center'>
                            Aucun service trouvé
                        </div>
                    ) : (
                        joueurs.map((joueur) => {
                            const age = joueur.date_naissance ? calculateAge(joueur.date_naissance) : '-';

                            return (
                                <div className="panel p-2 bg-white dark:bg-gray-700 rounded" key={joueur.id}>
                                    <div className="hstack gap-2">
                                        <div className="w-40px h-40px bg-gray-200 dark:bg-gray-600 rounded-circle overflow-hidden">
                                            <img src={`${fileUrl}/images/${joueur.photo ?? 'avatar.png'}`} alt={`${joueur.prenom} ${joueur.nom}`} className="w-100 h-100 object-cover" />
                                        </div>
                                        <div className="vstack gap-narrow flex-1">
                                            <h6 className="h6 m-0">{joueur.prenom} {joueur.nom}</h6>
                                            <div className="hstack gap-2 fs-7 text-gray-600">
                                                <span>Taille: {joueur.taille ? `${joueur.taille}m` : '-'}</span>
                                                <span>Poids: {joueur.poids ? `${joueur.poids}kg` : '-'}</span>
                                                <span>Poste: {joueur.poste ? `${joueur.poste}` : '-'}</span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            );
                        })
                    )}


                </div>
            </div>

            {/*Bloc Matchs à Venir */}
            <div className="panel p-4 bg-gray-25 dark:bg-gray-800 rounded-lg">
                <h3 className="h5 m-0 mb-3 text-primary">
                    <i className="fas fa-calendar-alt"></i>
                    Matchs à Venir
                </h3>
                <div className="vstack gap-2">


                    {
                        nextMatchs.length === 0 ? (
                            <div>
                                <p>Aucun match trouvé</p>
                            </div>
                        ) : nextMatchs.map((match, index) => (

                            <div key={index} className="hstack justify-between gap-2 p-2 bg-white dark:bg-gray-700 rounded">
                                <span className="fs-7">{truncateText(match.equipe_domicile?.nom || 'Domicile', 15)} vs {truncateText(match.equipe_exterieur?.nom || 'Extérieur', 15)}</span>
                                <span className="fs-7 text-gray-600">{truncateText(formatDateTimeFR(match.date_match), 10)}</span>
                            </div>
                        ))
                    }



                </div>
            </div>

            {/*Bloc Faire un Don */}
            <div className="panel p-4 bg-primary bg-opacity-5 rounded-lg">
                <div className="vstack gap-3 text-center">
                    <h3 className="h5 m-0 text-primary">
                        <i className="fas fa-heart"></i>
                        Soutenez-nous
                    </h3>
                    <p className="fs-6 m-0 text-gray-600">
                        Votre don permet d'offrir des opportunités à un jeune talent
                    </p>
                    <Link to="/donation" className="btn btn-primary btn-sm">
                        <i className="fas fa-donate"></i>
                        Faire un Don
                    </Link>
                </div>
            </div>

            {/*Bloc Publications Récentes */}
            <div className="panel p-4 bg-gray-25 dark:bg-gray-800 rounded-lg">
                <h3 className="h5 m-0 mb-3 text-primary">
                    <i className="fas fa-newspaper"></i>
                    Publications
                </h3>
                <div className="vstack gap-2 row">

                    <div className='row child-cols-12'>

                        {
                            categories.map((item, index) => (
                                <div key={index} className='lg:col-4 xl:col-4 mb-2'>
                                    <Link to={'/category/' + item.slug}>
                                        <span className="badge rounded-pill bg-primary me-1 mb-1">
                                            {item.titre}
                                        </span>

                                    </Link>

                                </div>


                            ))
                        }
                    </div>



                </div>

            </div>
            {/* objectif */}
            <div className='panel p-4 bg-gray-25 dark:bg-gray-800 rounded-lg'>
                <h3 className="h5 m-0 mb-3 text-primary">
                    <i className="fas fa-newspaper"></i>
                    Object, vision et mission
                </h3>

                <div className="vstack gap-2 row">
                    <div className='row child-cols-12'>

                        {sites.length === 0 ? (
                            <div>
                                <p>Aucun site trouvé</p>
                            </div>
                        ) : sites.map((item, index) => (

                            <div role="tabpanel" className="tab-pane active" id="home" key={index}>
                                <div className="widget_popular_news">
                                    <ul>
                                        <li>
                                            <div className="popular_news_text">
                                                <h3>Objectif</h3>

                                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.about ?? '') }} />
                                            </div>
                                        </li>
                                        <li className="widget-injuries">
                                            <div className="popular_news_text">
                                                <h3>Mission</h3>
                                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.mission ?? '') }} />
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        ))
                        }




                    </div>
                </div>
            </div>
            {/* fin objectif */}
            <br />

        </div>
    )
}
